/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwonat2Inputs */

const en_dropwonat2 = /** @type {(inputs: Dropwonat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Won on`)
};

const de_dropwonat2 = /** @type {(inputs: Dropwonat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewonnen am`)
};

/**
* | output |
* | --- |
* | "Won on" |
*
* @param {Dropwonat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwonat2 = /** @type {((inputs?: Dropwonat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwonat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwonat2(inputs)
	return de_dropwonat2(inputs)
});
export { dropwonat2 as "dropWonAt" }